import { createIcon } from '../createIcon';
import { ReactComponent as IconCheck } from '../svg/check.svg';

export default createIcon(IconCheck);
